import { ProductArrival } from '@app/models';
import {
    ProductArrivalActionTypes,
    ProductArrivalActionsUnion
} from '@core/actions/product-arrival.actions';

import {
    ProductActionsUnion
} from '@core/actions/product.actions';

import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<ProductArrival> {
  loading: boolean;
  loaded: boolean;
  busy: boolean;
}

export const adapter: EntityAdapter<ProductArrival> = createEntityAdapter<
  ProductArrival
>({
  selectId: (productArrival: ProductArrival) => productArrival.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  busy: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: ProductArrivalActionsUnion | ProductActionsUnion
) {
  switch (action.type) {
    case ProductArrivalActionTypes.LoadByFollow:
      return { ...state, loading: true, busy: true };

    case ProductArrivalActionTypes.LoadByFollowSuccess:
      return adapter.addAll(action.arrivals, {
        ...state,
        loading: false,
        loaded: true,
        busy: false
      });

    case ProductArrivalActionTypes.LoadByFollowFail:
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;

export const getState = createFeatureSelector<State>('productArrivals');

export const getAll = createSelector(
  getState,
  selectAll
);
export const getBusy = createSelector(
  getState,
  selectAll,
  (state: State) => state.busy
);
export const getEntities = createSelector(
  getState,
  selectEntities
);
